import { __assign, __rest, __spreadArrays } from "tslib";
import React, { useContext, useMemo, useState } from 'react';
var MarketplaceStoreContext = React.createContext(undefined);
export function MarketplaceStoreProvider(props) {
    var _a;
    var children = props.children, initialMarketplaceStore = __rest(props, ["children"]);
    var _b = useState(initialMarketplaceStore.metaSiteId), metaSiteId = _b[0], updateMetaSiteId = _b[1];
    var _c = useState(initialMarketplaceStore.prevRoute), prevRoute = _c[0], updatePrevRoute = _c[1];
    var _d = useState(initialMarketplaceStore.route), route = _d[0], updateRoute = _d[1];
    var _e = useState(initialMarketplaceStore.installedApps), installedApps = _e[0], updateInstalledApps = _e[1];
    var _f = useState(initialMarketplaceStore.bundleApps), bundleApps = _f[0], updateBundleApps = _f[1];
    var _g = useState(initialMarketplaceStore.currentBundleApps), currentBundleApps = _g[0], updateCurrentBundleApps = _g[1];
    var _h = useState(initialMarketplaceStore.userName), userName = _h[0], updateUserName = _h[1];
    var _j = useState(initialMarketplaceStore.userImage), userImage = _j[0], updateUserImage = _j[1];
    var _k = useState(initialMarketplaceStore.siteIsPremium), siteIsPremium = _k[0], updateSiteIsPremium = _k[1];
    var _l = useState(initialMarketplaceStore.siteHasDomain), siteHasDomain = _l[0], updateSiteHasDomain = _l[1];
    var _m = useState(initialMarketplaceStore.hideBusinessSolutionsInManageApps), hideBusinessSolutionsInManageApps = _m[0], updateHideBusinessSolutionsInManageApps = _m[1];
    var _o = useState((_a = initialMarketplaceStore.clearSearchBeforeDate) !== null && _a !== void 0 ? _a : Date.now()), clearSearchBeforeDate = _o[0], updateClearSearchBeforeDate = _o[1];
    var _p = useState(initialMarketplaceStore.permissions), permissions = _p[0], updatePermissions = _p[1];
    var _q = useState(initialMarketplaceStore.openedModalName), openedModalName = _q[0], updateOpenedModalName = _q[1];
    var _r = useState(initialMarketplaceStore.openedModalProps), openedModalProps = _r[0], updateOpenedModalProps = _r[1];
    function setMetaSiteId(newMetaSiteId) {
        updateMetaSiteId(newMetaSiteId);
    }
    function setRoute(newRoute) {
        updatePrevRoute(route);
        updateRoute(newRoute);
    }
    function setInstalledApps(newApps) {
        updateInstalledApps(__spreadArrays(newApps));
    }
    function setBundleApps(newApps) {
        updateBundleApps(newApps);
    }
    function setCurrentBundleApps(newApps) {
        updateCurrentBundleApps(newApps);
    }
    function setUserName(newUserName) {
        updateUserName(newUserName);
    }
    function setUserImage(newUserImage) {
        updateUserImage(newUserImage);
    }
    function setSiteIsPremium(newSiteIsPremium) {
        updateSiteIsPremium(newSiteIsPremium);
    }
    function setSiteHasDomain(newSiteHasDomain) {
        updateSiteHasDomain(newSiteHasDomain);
    }
    function setHideBusinessSolutionsInManageApps(newHideBusinessSolutionsInManageApps) {
        updateHideBusinessSolutionsInManageApps(newHideBusinessSolutionsInManageApps);
    }
    function resetClearSearchBeforeDate() {
        updateClearSearchBeforeDate(Date.now());
    }
    function setPermissions(newPermissions) {
        updatePermissions(newPermissions);
    }
    function openModal(newModalName, newModalProps) {
        updateOpenedModalName(newModalName);
        updateOpenedModalProps(newModalProps);
    }
    function closeAllModals() {
        updateOpenedModalName('none');
        updateOpenedModalProps({});
    }
    var marketplaceStore = useMemo(function () { return ({
        metaSiteId: metaSiteId,
        route: route,
        prevRoute: prevRoute,
        installedApps: installedApps,
        clearSearchBeforeDate: clearSearchBeforeDate,
        siteIsPremium: siteIsPremium,
        siteHasDomain: siteHasDomain,
        userName: userName,
        userImage: userImage,
        openedModalName: openedModalName,
        openedModalProps: openedModalProps,
        bundleApps: bundleApps,
        currentBundleApps: currentBundleApps,
        hideBusinessSolutionsInManageApps: hideBusinessSolutionsInManageApps,
        permissions: permissions,
        setMetaSiteId: setMetaSiteId,
        setRoute: setRoute,
        setInstalledApps: setInstalledApps,
        setBundleApps: setBundleApps,
        setCurrentBundleApps: setCurrentBundleApps,
        setUserName: setUserName,
        setUserImage: setUserImage,
        setSiteIsPremium: setSiteIsPremium,
        setSiteHasDomain: setSiteHasDomain,
        setHideBusinessSolutionsInManageApps: setHideBusinessSolutionsInManageApps,
        resetClearSearchBeforeDate: resetClearSearchBeforeDate,
        setPermissions: setPermissions,
        openModal: openModal,
        closeAllModals: closeAllModals,
    }); }, [
        metaSiteId,
        JSON.stringify(route),
        JSON.stringify(prevRoute),
        JSON.stringify(installedApps),
        // clearSearchBeforeDate,
        siteIsPremium,
        siteHasDomain,
        userName,
        userImage,
        openedModalName,
        // openedModalProps,
        JSON.stringify(bundleApps),
        JSON.stringify(currentBundleApps),
        hideBusinessSolutionsInManageApps,
        JSON.stringify(permissions),
    ]);
    return (React.createElement(MarketplaceStoreContext.Provider, { value: marketplaceStore }, children));
}
export function useMarketplaceStore() {
    var context = useContext(MarketplaceStoreContext);
    if (context === undefined) {
        throw new Error('useMarketplaceStore must be used within a MarketplaceStoreProvider');
    }
    return context;
}
export function withMarketplaceStore(BaseComponent) {
    return function (props) { return (React.createElement(MarketplaceStoreContext.Consumer, null, function (marketplaceStore) { return (React.createElement(BaseComponent, __assign({}, props, { marketplaceStore: marketplaceStore }))); })); };
}
//# sourceMappingURL=with-marketplace-store.js.map